// test: jest src/models/__tests__/Service.model.spec.js
export default class Service {
  constructor({
    id,
    collection_id,
    type,
    title,
    titleOfTitleField,
    image,
    description,
    price = 0,
    duration = 0,
    // Keep raw data if needed, but don't expose it publicly
    _rawData = null
  }) {
    this._id = id;
    this._collection_id = collection_id;
    this._type = type;
    this._title = title;
    this._titleOfTitle = titleOfTitleField;
    this._image = image;
    this._description = description;
    this._price = price || 0;
    this._duration = Number(duration) || 0;
    this._rawData = _rawData; // Private, for internal use only
  }

  // Factory method for creating from collection item
  static fromCollectionItem(collectionItem, fieldMappings) {
    const fields = collectionItem.data.reduce((acc, field) => {
      acc[field.field_id] = field.value;
      return acc;
    }, {});

    return new Service({
      id: collectionItem.id,
      collection_id: collectionItem.collection_id,
      type: collectionItem.type,
      title: fields[fieldMappings.title],
      titleOfTitleField: collectionItem.data.find((data) => data.field_id === fieldMappings.title)?.title,
      image: fields[fieldMappings.image],
      description: fields[fieldMappings.description],
      price: fields[fieldMappings.price],
      duration: fields[fieldMappings.duration],
      _rawData: collectionItem // Optional: store raw data privately
    });
  }

  // Read-only properties
  get id() { return this._id; }
  get collection_id() { return this._collection_id; }
  get type() { return this._type; }
  get title() { return this._title; }
  get titleOfTitleField() { return this._titleOfTitle; }
  get image() { return this._image; }
  get description() { return this._description; }
  get price() { return this._price; }
  get duration() { return this._duration; }
}
